import React from 'react';
import io from "socket.io-client"; 
const basePath = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BASE_PATH) ? process.env.REACT_APP_BASE_PATH : '';
export const socket = io(basePath+'/socket');
export const SocketContext = React.createContext();